import * as types from '../constants/EventtickerActionTypes'
import {env} from '../constants/Environment';
import { isDate, isObject } from 'util';

export function start_listening(unsubscribe){
    return {
        type: types.START_LISTENING,
        listener: unsubscribe
    }
}

export function stop_listening(){
    return {
        type: types.STOP_LISTENING
    }
}

export function add_event(events){
    return {
        type: types.ADD_EVENT,
        events: events
    }
}

export function append_event(events){
    return {
        type: types.APPEND_EVENT,
        events: events
    }
}

export function start_loading_events(){
    return {
        type: types.START_LOADING_EVENTS
    }
}

export function done_loading_events(timestamp){
    return {
        type: types.DONE_LOADING_EVENTS,
        timestamp: timestamp
    }
}

export function stop_listener(listener){
	return function(dispatch){		
        return (new Promise((resolve, reject) => {				
				(async () => {
					listener();

                    dispatch(stop_listening());
                    resolve();
                });
			}));
    }
}

export function start_listener (firestore) {
	return function(dispatch){		
        return (new Promise((resolve, reject) => {		
				(async () => {
                    let now = Date.now();
                    await dispatch(load_events(firestore, now));

					let unsubscribe = firestore.collection('environments/' + env + '/channels/bookmaker/ticker').where('timestamp', '>=', new Date(now)).orderBy("timestamp", "desc").limit(50).onSnapshot(function(querySnapshot) {
                        var events = [];
                        
                        querySnapshot.forEach(function(doc) {
                            let data = doc.data();
                            data.id = doc.id;
                            events.push(data);
                        });

                        dispatch(add_event(events));
                    });

                    dispatch(start_listening(unsubscribe));
                    resolve();
                })();
			}));
	}
}

export function load_events (firestore, timestampStart) {
	return function(dispatch){
        dispatch(start_loading_events());		
        return (new Promise((resolve, reject) => {				
				(async () => {
					let querySnapshot = await firestore.collection('environments/' + env + '/channels/bookmaker/ticker').where('timestamp', '<', new Date(timestampStart)).orderBy("timestamp", "desc").limit(50).get();
                    let minTimestamp = new Date(timestampStart);

                    var events = [];
                    querySnapshot.forEach(function(doc) {
                        let data = doc.data();
                        data.id = doc.id;
                        events.push(data);

                        minTimestamp = data.timestamp.toDate();
                    });

                    dispatch(append_event(events));

                    dispatch(done_loading_events(minTimestamp.valueOf()));
                    resolve();
                })();
			}));
	}
}

function start_select_oe(uid, plusId){
    return {
        type: types.START_SELECT_OE,
        id: uid,
        plusId: plusId
    }
}

function done_select_oe(events){
    return {
        type: types.DONE_SELECT_OE,
        events: events
    }
}

/*function append_oe_event(events){
    return {
        type: types.APPEND_OE_EVENT,
        events: events
    }
}*/

/*function done_unselect_oe(){
    return {
        type: types.UNSELECT_OE
    }
}*/

export function unselect_oe(listener){
    return {
        type: types.UNSELECT_OE
    }

	/*return function(dispatch){		
        return (new Promise((resolve, reject) => {				
				(async () => {
					listener();

                    dispatch(done_unselect_oe());
                    resolve();
                });
			}));
    }*/
}

export function select_oe (firestore, uid, plusId) {
    return function(dispatch){
        dispatch(start_select_oe(uid, plusId));		
        return (new Promise((resolve, reject) => {				
				(async () => {
					let querySnapshot = await firestore.collection('environments/' + env + '/channels/bookmaker/ticker').where('uid', '==', uid).orderBy("timestamp", "desc").get();
                    var events = [];
                    querySnapshot.forEach(function(doc) {
                        let data = doc.data();
                        data.id = doc.id;
                        events.push(data);
                    });

                    dispatch(done_select_oe(events));
                    resolve();
                })();
			}));
	}
}

function start_search(){
    return {
        type: types.START_SEARCH
    }
}

export function search(firestore, plusId){
    return function(dispatch){
        dispatch(start_search());

        return (new Promise((resolve, reject) => {				
				(async () => {
					let snapshot = await firestore.collection('environments/' + env + '/channels/bookmaker/by-plus-id').doc(String(plusId)).get();

                    if(!snapshot.exists){
                        dispatch({
                            type: types.DONE_SEARCH,
                            hasResults: false,
                            choose: null
                        })
                    }else{
                        let data = snapshot.data();
                        let keys = Object.keys(data);

                        if(keys.length === 1){
                            //await select_search_result(firestore, keys[0], plusId);

                            dispatch(select_search_result(firestore, keys[0], plusId))

                        }else{
                            let promises = [];
                            
                            for(var uid in data){
                                promises.push(firestore.collection('environments/' + env + '/channels/bookmaker/ticker').where('uid', '==', uid).orderBy("timestamp", "desc").limit(1).get());
                            }

                            let snapshots = await Promise.all(promises);
                            var results = [];

                            snapshots.forEach((snapshot) => {
                                snapshot.forEach((result) => {
                                    results.push(result.data());
                                });
                            });

                            results.sort((a, b) => a.timestamp - b.timestamp);

                            dispatch({
                                type: types.DONE_SEARCH,
                                hasResults: true,
                                choose: results
                            })
                        }
                    }

                    resolve();
                })();
			}));
	}
}

export function close_search(){
    return {
        type: types.CLOSE_SEARCH
    }
}

export function select_search_result(firestore, uid, plusId){
    return function(dispatch){
        dispatch(close_search());
        dispatch(select_oe(firestore, uid, plusId));
    }
}